import { Collapse as bsCollapse } from 'bootstrap';

class AccordionControl {

    constructor(el) {
        this.el = el;
        this.openBtn = el.querySelector('.accordion--open-all');
        this.closeBtn = el.querySelector('.accordion--close-all');
        this.accordian = document.querySelector(`#${el.dataset.accordionId}`);
        if(this.accordian != null) {
            this.expanders = [];
            let findExpanders = this.accordian.querySelectorAll('.expander > .collapse');
            findExpanders.forEach(e => {
                //console.log(`collapse show: ${e.classList.contains('show')}`);
                let options = {toggle: false};
                e.classList.contains('show') ? options.show = true : options.hide = true;
                this.expanders.push(bsCollapse.getOrCreateInstance(e, options));
            });
            // button behaviours
            this.openBtn.onclick = () => {
                this.toggle(true);
            }
            this.closeBtn.onclick = () => {
                this.toggle(false);
            }
        }
    }

    toggle(mode) {
        this.expanders.forEach(e => {
            if(mode) {
                e.show();
            } else {
                e.hide();
            }
        });
    }

}

// export the default function to create
export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new AccordionControl(node);
        }
    });
}